export default __webpack_public_path__ + "eec511d.png";